import { Box } from "@chakra-ui/react";

function Card({ children, ...rest }) {
  return (
    <Box boxShadow='lg' p='6' rounded='md' bg='white' {...rest}>
      {children}
    </Box>
  );
}

export default Card;
